/**
 * Holds the `SocialRoom` connection for the whole signed-in session, and renders
 * the one piece of social UI that has to survive a navigation.
 *
 * Mounted in `App` beside `<ToastViewport/>` rather than inside `AppShell`,
 * deliberately: the table route lives *outside* the shell — it owns the whole
 * viewport — so a connection held by the shell would drop the moment a player
 * sat down, which is exactly when an invitation most needs to reach them.
 */

import { useSocialRoom } from '../../net/social';

import { InviteToasts } from './InviteToasts';

export function SocialProvider() {
  useSocialRoom();
  return <InviteToasts />;
}
